<template>
  <header class="page-header mb-0" data-gtm-context="Hero">
    <div class="container-fluid">
      <div class="row center-xs">
        <div v-if="kicker" class="col-xs-12 col-sm-10">
          <div class="page-header__kicker--gradient mb-4 hero-fade-in">
            <img :src="require('@/assets/images/icons/' + kicker.icon + '-filled-' + kicker.theme + '.svg')" />
            {{ kicker.text }}
          </div>
        </div>
        <div class="col-xs-12" :class="wide ? 'col-sm-10' : 'col-sm-8'">
          <h1 class="mb-4 hero-fade-in" :class="{ 'hero-fade-in--delay-1': !!kicker }">{{ title }}</h1>
        </div>
        <div class="col-xs-12" :class="wide ? 'col-sm-8' : 'col-sm-6'">
          <p
            v-if="subtitleText"
            class="mb-8 p--lg hero-fade-in"
            :class="kicker ? 'hero-fade-in--delay-2' : 'hero-fade-in--delay-1'"
          >
            {{ subtitleText }}
          </p>
          <div
            v-if="buttonText && buttonLink"
            :class="['hero-fade-in', kicker ? 'hero-fade-in--delay-3' : 'hero-fade-in--delay-2']"
          >
            <router-link
              :to="{ name: buttonLink }"
              title="{{ buttonText }}"
              class="btn btn--primary"
              >{{ buttonText }}</router-link>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "PageHeaderFeature",
  components: {
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitleText: {
      type: String,
      required: false,
    },
    buttonText: {
      type: String,
      required: false,
    },
    buttonLink: {
      type: String,
    },
    kicker: {
      type: Object,
    },
    wide: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
